import { describeError } from '../api/client'
import { StatusBanner } from './StatusBanner'

/** "Could not load [what]: …" when [error] is set, else nothing: the one failed-load banner every page shows. */
export function LoadError(props: { what: string; error: Error | null | undefined }) {
  return props.error ? (
    <StatusBanner tone="error">
      Could not load {props.what}: {describeError(props.error)}
    </StatusBanner>
  ) : null
}
